import React from "react";
import HomepageBrandValue from "web/react/components/homepage-brand-value/homepage-brand-value";
import TopProducts from "web/react/components/top-products/top-products";
import TopLysts from "web/react/components/top-lysts/top-lysts";
import HomepageBreakoutBrands from "web/react/components/homepage-breakout-brands/homepage-breakout-brands";
import HomepageCategoryLinks from "web/react/components/homepage-category-links/homepage-category-links";
import HomepageMostWantedRail from "web/react/components/homepage-most-wanted-rail/homepage-most-wanted-rail";
import PromoBanner from "web/react/components/promo-banner/promo-banner";
import styles from "./homepage-layout.css";
export function HomepageLayout(_ref) {
  var _ref$layoutData = _ref.layoutData,
      popularProducts = _ref$layoutData.homepage_popular_products,
      brandValues = _ref$layoutData.homepage_brand_values,
      featuredBanners = _ref$layoutData.homepage_featured_banners,
      breakoutBrands = _ref$layoutData.homepage_breakout_brands,
      trends = _ref$layoutData.homepage_trends,
      genericTypes = _ref$layoutData.homepage_generic_types,
      promoBanner = _ref$layoutData.homepage_promo_banner;
  return React.createElement("div", {
    className: styles.homepageLayout
  }, promoBanner && React.createElement(PromoBanner, promoBanner), popularProducts && React.createElement(TopProducts, {
    title: popularProducts.title,
    products: popularProducts.products
  }), featuredBanners && React.createElement(TopLysts, featuredBanners), breakoutBrands && React.createElement(HomepageBreakoutBrands, breakoutBrands), brandValues && React.createElement(HomepageBrandValue, brandValues), trends && React.createElement(HomepageMostWantedRail, trends), genericTypes && React.createElement(HomepageCategoryLinks, {
    genericTypes: genericTypes
  }));
}
export default HomepageLayout;